import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Table } from "react-bootstrap";
import {
  EventApplicationRetailService,
  GlobalSettingService,
  PaymentService,
} from "../../../services";
import { formatAmount, formatDateENGB, handleConsoleError } from "../../../utils/common-methods";
import { globalConstant } from "../../../constants/globalConstant";
import { toast } from "react-toastify";
const RetailPayment = ({ props }) => {
  //  const loginUser = AuthService.getLoginUser();
  const [litterData, setLitterData] = useState([]);
  //  const [applicationFees, setApplicationFees] = useState();
  //  const [buyerFee, setBuyerFee] = useState();
  //  const [processingFee, setProcessingFee] = useState();
  //  const [amount, setAmount] = useState();

  const {
    getValues,
    // register,
    setValue,
    // formState: { errors },
  } = useFormContext();
  const eventApplicationRetailId = getValues("retailApplicationFormData.id");
  const initialPaymentPer = getValues(
    "retailApplicationFormData.initialPaymentPer"
  );
  const dueDuePaymentDate = getValues("retailApplicationFormData.payOutDate");

  const getLinkAccount = async () => {
    try {
      const res = await PaymentService.getConnectedAccountByEventId(
        getValues("retailApplicationFormData.eventId")
      );
      if (res?.isSuccess) {
        setValue("payment.connectedAccountId", res?.data?.stripeAccountId);
      }
    } catch (error) {
      // setIsProfileAvailable(false);
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getLitterData = async () => {
    try {
      let isEoVatRegister = false;
      let isPlatformVatRegister = true;
      let vatPercent = 0;
      const response = await GlobalSettingService.getGlobalSettingList();

      if (response?.isSuccess && response?.data?.length > 0) {
        const vat = response?.data?.find(
          (item) => item.keyName.trim() === globalConstant.VAT_PERCENT.trim()
        );
        if (vat) {
          vatPercent = vat.keyValue;
        }
      }

      const res = await EventApplicationRetailService.getRetailApplicationPaymentById(
        eventApplicationRetailId
      );
      if (res?.isSuccess && res?.data?.length > 0) {
        setLitterData(res?.data);
        //Total Payable
        const applicationFee = res?.data.find((s) =>
          s.name.toLowerCase().includes("Application Fee".toLowerCase())
        );
        if (applicationFee) {
          if (applicationFee?.vat > 0) {
            isEoVatRegister = true;
          }
          if (isEoVatRegister === true && isPlatformVatRegister === false) {
            const vatApp = applicationFee?.vat;
            setValue("payment.applicationFee", applicationFee?.total - vatApp);
          } else if (
            isPlatformVatRegister === true &&
            isEoVatRegister === false
          ) {
            const vatApp = (applicationFee?.total * vatPercent) / 100;
            setValue("payment.applicationFee", applicationFee?.total + vatApp);
          } else {
            setValue("payment.applicationFee", applicationFee?.total);
          }
        }
        const buyerFee = res?.data.find((s) =>
          s.name.toLowerCase().includes("Buyer Fee (".toLowerCase())
        );
        if (buyerFee) {
          if (isEoVatRegister === true && isPlatformVatRegister === false) {
            const vatBuyer = buyerFee?.vat;
            setValue("payment.buyerFee", buyerFee?.total - vatBuyer);
          } else if (
            isEoVatRegister === false &&
            isPlatformVatRegister === true
          ) {
            const vatBuyer = (buyerFee?.total * vatPercent) / 100;
            setValue("payment.buyerFee", buyerFee?.total + vatBuyer);
          } else {
            setValue("payment.buyerFee", buyerFee?.total);
          }
        }

        const processingFee = res?.data?.find((s) =>
          s.name.toLowerCase().includes("Processing Fees (".toLowerCase())
        );
        if (processingFee) {
          setValue("payment.processingFee", processingFee?.total);
        }

        const totalPayable = res?.data?.find((s) =>
          s.name.toLowerCase().includes("Total Payable".toLowerCase())
        );

        if (totalPayable) {
          const partAmount =
            totalPayable?.total * ((initialPaymentPer ?? 0) / 100);

          setValue("payment.amount", roundDown(partAmount, 2));
          setValue("payment.remainingAmount", totalPayable?.total - partAmount);
        }
        setValue("payment.initialPaymentPer", initialPaymentPer);
      }
    } catch (error) {
      // setIsProfileAvailable(false);
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const roundDown = (value, decimals) => {
    const factor = Math.pow(10, decimals);
    //return Math.floor(value * factor) / factor;
    return Math.floor((value +1e-10)* factor) / factor; //TODO calculation fix
  };

  useEffect(() => {
    const bootstrapAsync = async () => {
      props.application.setLoading(true);
      await getLinkAccount();
      await getLitterData();
      props.application.setLoading(false);
    };
    bootstrapAsync();
  }, []);
  return (
    <React.Fragment>
      <div role="tabpanel" className="tab-pane" id="Submit">
        <h2 className="retail-form-hd1">Payment details</h2>
        <p>
          Invoices will be issued to all successful applicants with VAT added(where applicable).
        </p>
        {/* <p>
          {initialPaymentPer}% payment (including electricity and any other
          charges) is due immediately with the remaining balance due within a
          maximum of 14 days after invoice.
        </p> */}
        {initialPaymentPer < 100 && (
          <p>
            {initialPaymentPer}% payment (including electricity and any other
            charges) is due immediately with the remaining balance due on{" "}
            {formatDateENGB(dueDuePaymentDate)}.
          </p>
        )}
        {initialPaymentPer === 100 && (
          <p>
            {initialPaymentPer}% payment (including electricity and any other
            charges) is due immediately.
          </p>
        )}
        <p>
          Non-payment will result in the stall being reallocated and the loss of
          your deposit.
        </p>
        {/* <p>
          Payments should be made direct via a bank transfer (details below).
        </p>
        <br />
        <p>
          Once payment has been made please email traders@swallowevents.com with
          your company as payment reference.
        </p> */}

        <section className="edit-form-table">
          <div className="container mt-3">
            <div className="table-responsive">
              {/* BACS		◻ */}
              {/* <Form.Group controlId="amount">
                <Form.Control
                  type="hidden"
                  {...register("payment.amount")}
                  defaultValue={amount}
                  // onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="applicationFee">
                <Form.Control
                  type="hidden"
                  {...register("payment.applicationFee")}
                  defaultValue={applicationFees}                 
                />
              </Form.Group>
              <Form.Group controlId="buyerFee">
                <Form.Control
                  type="hidden"
                  {...register("payment.buyerFee")}
                  defaultValue={buyerFee}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="processingFee">
                <Form.Control
                  type="hidden"
                  {...register("payment.processingFee")}
                  defaultValue={processingFee}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="remainingAmount">
                <Form.Control
                  type="hidden"
                  {...register("payment.remainingAmount")}
                  defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="initialPaymentPer">
                <Form.Control
                  type="hidden"
                  {...register("payment.initialPaymentPer")}
                  defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="connectedAccountId">
                <Form.Control
                  type="hidden"
                  {...register("payment.connectedAccountId")}
                  defaultValue={applicationFees}
                  //  onChange={handleInputChange}
                />
              </Form.Group> */}
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Amount (£)</th>
                    <th>Vat (£)</th>
                    <th>Total (£)</th>
                  </tr>
                </thead>
                <tbody>
                  <React.Fragment>
                    {litterData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{item?.name}</td>
                          <td>£{formatAmount(item?.amount)}</td>
                          <td>£{formatAmount(item?.vat)}</td>
                          <td>£{formatAmount(item?.total)}</td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                </tbody>
              </Table>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default RetailPayment;
